<div class="container">
    <div class="poBox" >
        <h2 class="boldLIght"><strong>What's</strong> New</h2>
        <div >
        <div class="videoSlider">
            <div class="newProduct bigarrow" *ngFor="let youVideo of bannarVideos">
                <div class="poInnerBox" >
                    <div class="poCardwrap__Fullwidth">                     
                        <iframe class="frameVideo" [src]="youVideo.url | safe" 
                        allowfullscreen
                        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-presentation"
                         alt=""></iframe>
                      </div>                      
                </div>
                <div class="swiper-scrollbar"></div>
            </div>
        </div>
    </div>
    </div>
    <div class="poBox pobox30">
        <h2 class="boldLIght"><strong>Offers</strong></h2>
        <div class="">
            <div class="newProduct bigarrow">
                <div class="poInnerBox">
                    <div class="poCardwrap offerBanner">
                        <div class="reviewSlider">
                            <div class="reviewItem offerBanner"  *ngFor="let offer of bannerSection">
                                <a [href]="offer.redirectUrl" queryParamsHandling="merge">
                                    <img src="{{offer.url}}" alt="" /></a>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="swiper-scrollbar"></div>
            </div>
        </div>
    </div>
    <div class="poBox pobox30" *ngIf="reviews.length > 0">
        <h2 class="boldLIght"><strong>Our </strong>Store</h2>
        <div class="">
            <div class="newProduct bigarrow">
                <div class="poInnerBox">
                    <div class="poCardwrap wrapReviewSlider">
                        <div>
                            <h3>Dell Stores Rating</h3>
                            <p>Average rating of all our stores</p>
                            <div class="starRatingwrap">
                                <img src="./assets/img/rednewstar.svg" alt=""> {{reviews[0].averate_rating}}
                            </div>
                        </div>
                        <div class="reviewSliderNew">
                            <h3>Customer Speak</h3>
                            <div class="rsWrap">
                                <div class="rsSlide" aria-label="slide 1 of 3" >
                                    <div class="rsTop">
                                        <i class="profilePhoto">
                                            <img src="./assets/img/avatar.png" alt="">
                                        </i>
                                        <div class="rsDetail">
                                            <h4>{{reviews[0].display_Name}}</h4>
                                            <h5>{{reviews[0].crt_Dt | date : 'mediumDate'}}</h5>
                                        </div>
                                        <abbr class="cstReview">
                                            <img src="./assets/img/singleStarred.svg" alt=""> {{reviews[0].star_Rating}}
                                        </abbr>
                                    </div>
                                    <div class="custrevText">
                                        <p>{{reviews[0].comment}}</p>
                                    </div>
                                </div>

                                <div class="rsSlide" aria-label="slide 2 of 3" >
                                    <div class="rsTop">
                                        <i class="profilePhoto">
                                            <img src="./assets/img/avatar.png" alt="">
                                        </i>
                                        <div class="rsDetail">
                                            <h4>{{reviews[1].display_Name}}</h4>
                                            <h5>{{reviews[1].crt_Dt | date : 'mediumDate'}}</h5>
                                        </div>
                                        <abbr class="cstReview">
                                            <img src="./assets/img/singleStarred.svg" alt=""> {{reviews[1].star_Rating}}
                                        </abbr>
                                    </div>
                                    <div class="custrevText">
                                        <p>{{reviews[1].comment}}</p>
                                    </div>
                                </div>
                                <div class="rsSlide" aria-label="slide 1 of 3" >
                                    <div class="rsTop">
                                        <i class="profilePhoto">
                                            <img src="./assets/img/avatar.png" alt="">
                                        </i>
                                        <div class="rsDetail">
                                            <h4>{{reviews[2].display_Name}}</h4>
                                            <h5>{{reviews[2].crt_Dt | date : 'mediumDate'}}</h5>
                                        </div>
                                        <abbr class="cstReview">
                                            <img src="./assets/img/singleStarred.svg" alt=""> {{reviews[2].star_Rating}}
                                        </abbr>
                                    </div>
                                    <div class="custrevText">
                                        <p>{{reviews[2].comment}}</p>
                                    </div>
                                </div>                                <!-- <div class="rsSlide" aria-label="slide 2 of 3">
                                    <div class="rsTop">
                                        <i class="profilePhoto">
                                            <img src="./assets/img/avatar.png" alt="">
                                        </i>
                                        <div class="rsDetail">
                                            <h4>Vunnam Hari Babu</h4>
                                            <h5>19th April'22</h5>
                                        </div>
                                        <abbr class="cstReview">
                                            <img src="./assets/img/singleStarred.svg" alt=""> 4.5
                                        </abbr>
                                    </div>
                                    <div class="custrevText">
                                        <p>Small one good store with customer friendly.</p>
                                    </div>
                                </div>
                                <div class="rsSlide"  aria-label="slide 3 of 3">
                                    <div class="rsTop">
                                        <i class="profilePhoto">
                                            <img src="./assets/img/avatar.png" alt="">
                                        </i>
                                        <div class="rsDetail">
                                            <h4>Srinivasan T</h4>
                                            <h5>24th April'22</h5>
                                        </div>
                                        <abbr class="cstReview">
                                            <img src="./assets/img/singleStarred.svg" alt=""> 4.5
                                        </abbr>
                                    </div>
                                    <div class="custrevText">
                                        <p>Very pleasant experience. Shilpa, Ashwini and Nandini were very courteous and
                                            helping. Thanks a lot!</p>
                                    </div>
                                </div> -->
                            </div>

                        </div>
                    </div>

                </div>
                <div class="swiper-scrollbar"></div>
            </div>
        </div>
    </div>
</div>
